import { RootState } from 'types/state'

export const SET_RIGHT_DRAWER_OPEN = 'SET_RIGHT_DRAWER_OPEN'

export const drawersActions = {
  setRightDrawerOpen: (type?: RightDrawerType) => ({
    type: SET_RIGHT_DRAWER_OPEN,
    rightDrawerOpen: type,
  }),
}

export type RightDrawerType = 'helpCenter' | 'designBackups'

interface RightDrawerOpenAction {
  type: typeof SET_RIGHT_DRAWER_OPEN
  rightDrawerOpen: RightDrawerType | undefined
}

const initialState: DrawersState = {
  rightDrawerOpen: undefined,
}

export default (previousState: DrawersState = initialState, action: RightDrawerOpenAction) => {
  if (action.type === SET_RIGHT_DRAWER_OPEN) {
    previousState = {
      ...previousState,
      ...{
        rightDrawerOpen: action.rightDrawerOpen,
      },
    }
  }
  return previousState
}

export type DrawersState = {
  rightDrawerOpen: RightDrawerType | undefined
}

export const drawersSelectors = {
  getRightDrawerOpen(state: RootState): RightDrawerType | undefined {
    return state.drawers.rightDrawerOpen
  },
  getHelpCenterOpen(state: RootState): boolean {
    return drawersSelectors.getRightDrawerOpen(state) === 'helpCenter'
  },
  getDesignBackupOpen(state: RootState): boolean {
    return drawersSelectors.getRightDrawerOpen(state) === 'designBackups'
  },
}
